import cx from 'classnames'
import style from './Footer.css'

const Footer = () => {
  return (
    <footer className={style.footer}>
      <PageFooter />
    </footer>
  )
}

export const PageFooter = ({ className }) => (
  <div
    id='footer'
    className={cx(style.pageFooter, className)}
  >
    <div className={style.pageFooterText}>
      <div className={style.copyrights}>
        香港商雅虎資訊股份有限公司台灣分公司  版權所有 ©
        {' '}
        {(new Date()).getFullYear()}
      </div>
    </div>
  </div>
)

export default Footer
